export default __webpack_public_path__ + "static/media/Vector.92f9bca5.svg";